import React, { useContext, useEffect, useMemo } from 'react';
import { useUser } from '../hooks/useUser';

export const UserContext = React.createContext()

export const UserProvider = ({ children }) => {
    const userState = useUser();
    const value = useMemo(() => userState, [userState])

    //useEffect(() => { console.log("UserProvider => ", value) }, [value])

    return (
        <UserContext.Provider value={value}>
            {children}
        </UserContext.Provider>
    );
}

export function useUserContext() {
    return useContext(UserContext)
}
